// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"3ca0188aa663b0ab586f","387":"0dc154b2a3b5ea89d9ee","760":"25d09d492f31e59ed59e","860":"91114b66dae855a81ca7"}[chunkId] + ".chunk.js";
};